
import { useSidClient } from "@/plugins/auth";
import { useRouter } from "vue-router";
import { defineComponent, ref } from "vue";
import { Field, Form } from "vee-validate";
import { checkEmail } from "@/commons/inputCheckCommon";
import * as Yup from "yup";
import useDeterring from "@/commons/useDeterring";
import { QuestionnaireItem } from "@/modules/questionnaire/questionnaireInfo";
import { reEncodeUriComponent } from "@/commons/commonUtility";

export default defineComponent({
    name: "QuestionnaireResetPassword",
    components: {
        Form,
        Field
    },
    setup() {
        const sidClient = useSidClient();
        const router = useRouter();
        const { isDeterringRef, asyncDeterringWrap } = useDeterring();
        const { questionnaireInfo, routeNames } = QuestionnaireItem.inject();

        const emailRef = ref("");
        const errorMsgRef = ref("");

        const schema = Yup.object().shape({
            email: checkEmail
        });

        /**
         * パスワードリセット要求
         * @async
         */
        const forgotPassword = async () => {
            await sidClient.forgotPassword(
                emailRef.value,
                {
                    LinkageName: "questionnaire",
                    CodeChallenge: questionnaireInfo?.codeChallenge,
                    CallbackUrl: reEncodeUriComponent(questionnaireInfo?.callbackUrl)
                }
            )
                .then(() => {
                    // eslint-disable-next-line
                    router.push({name: routeNames.SET_PASSWORD, query: {reset_email: emailRef.value}});
                })
                .catch(() => {
                    errorMsgRef.value = "エラーが発生しました。お手数をおかけしますが、しばらく時間を置いてから、再度操作していただけますようお願いいたします。";
                });
        };

        return {
            isDeterringRef,
            asyncDeterringWrap,
            emailRef,
            errorMsgRef,
            schema,
            forgotPassword,
        };
    },
});
